import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-accepter-devis',
  templateUrl: './accepter-devis.component.html',
  styleUrls: ['./accepter-devis.component.scss']
})
export class AccepterDevisComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
